import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import WorkspaceContext from './context';
import { useDefaultWorkspace } from '../../hooks/useDefaultWorkspace';

import WorkspaceEmptyModal from '../../views/base/WorkspaceEmptyModal';

const WorkspaceContextProvider = ({ children }) => {
  const workspace = useDefaultWorkspace();

  const value = useMemo(() => ({
    workspace,
  }), [workspace]);

  return (
    <WorkspaceContext.Provider value={value}>
      {children}

      <WorkspaceEmptyModal />
    </WorkspaceContext.Provider>
  );
};

WorkspaceContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default WorkspaceContextProvider;
